export enum ElementTypesEnum {
    Grouping = "grouping",
    Input = "input",
    Markdown = "markdown",
    Image = "image"
}
